import * as DateFns from 'date-fns';

import { MESSAGES } from '../../config/constants';
import { SERVER } from '../../config/server.config';
import { routeToSpecificScope } from '../../helpers/helpersts';
import { requestData } from '../../config/services/datasets';
import * as eventTypes from '../types';
import { updateMetaDataEvent } from './dataEvents';
import { addLoadingFlag, changeMessageLoading, subLoadingFlag } from './loading';

export const replaceDataProcessingStatus = (data) => {
  return {
    type: eventTypes.REPLACE_PROCESSING_STATUS_DATA,
    data
  };
};

export const loadDataProcessingStatus = (tzOffset) => {
  return async (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const scope = routeToSpecificScope(path);
    dispatch(addLoadingFlag(scope));
    const results = await requestData(SERVER.PROCESSING_STATUS(getState().user.teamId, undefined, tzOffset));
    if (results && results[0]) {
      dispatch(replaceDataProcessingStatus(results[0]));
    } else {
      dispatch(changeMessageLoading(scope, MESSAGES.EMPTY));
    }
    dispatch(subLoadingFlag(scope));
  };
};

export const loadPracticeProcessingStatus = (gameId, endTime, teamId, fullStatus) => {
  return async (dispatch, getState) => {
    dispatch(updateMetaDataEvent(gameId, {processingFetch: true}));
    const results = await requestData(SERVER.PROCESSING_STATUS(getState().user.teamId, gameId, undefined, fullStatus));
    const data = results && results[0] && results[0].data;
    if (data && teamId) {
      data.forEach(group => {
        const dateKey = Object.keys(group)[0];
        const nowDate = DateFns.format(new Date(), 'yyyy-MM-dd');
        let isComplete = false;
        let indexComplete = 0;
        let indexInProgress = 0;
        if ((dateKey === nowDate || DateFns.isToday(endTime))){
          for(let i = 0; i < group[dateKey][teamId].length; i++ ){
            if(group[dateKey][teamId][i].live === "false" &&  group[dateKey][teamId][i].status === 'COMPLETE'){
              isComplete = true;
              indexComplete= i;
              break;
            }
          }
          if(isComplete){
            dispatch(updateMetaDataEvent(gameId, { completePercentProcessingStatus: (group[dateKey] && group[dateKey][teamId][indexComplete] 
              && group[dateKey][teamId][indexComplete].completePercent) || '0.0', 
            processingStatus: 'COMPLETE' }));
          }else{
            for(let j= 0; j < group[dateKey][teamId].length; j++ ){
              if(group[dateKey][teamId][j].live === "false" &&  group[dateKey][teamId][j].status === 'INPROGRESS'){
                indexInProgress = j;
                break;
              }
            }
              dispatch(updateMetaDataEvent(gameId, { completePercentProcessingStatus: (group[dateKey] && group[dateKey][teamId][indexInProgress] 
                && group[dateKey][teamId][indexInProgress].completePercent) || '0.0', 
              processingStatus: ((group[dateKey] && group[dateKey][teamId][indexInProgress] && group[dateKey][teamId][indexInProgress].status) || 'INPROGRESS') }));
          };
        }
      });
    }
    dispatch(updateMetaDataEvent(gameId, {processingFetch: false}));
  };
};
